import React, { useState, useEffect, Fragment } from 'react'

import { ConfirmModal, Spinner } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { bool } from 'prop-types'

import ModelUploader from './ModelUploader/ModelUploader'

function ConfirmHeader() {
  return <span className="cgt-legacy-heading-h5">You are switching to the legacy Upload page.</span>
}

let NewModelUploader

function Publisher({ newPublisherView, ...rest }) {
  const [state, setState] = useState({
    isLegacyMode: false,
    isConfirmModalOpen: false,
    isModuleLoaded: false,
  })

  function handleLayoutSwitch() {
    // this is a function to handle layout switch to make legacy view available.
    // remove this after full rollout.
    //
    const element = document.querySelector('.publisher-page')

    if (element) {
      element.classList.toggle('legacy-view')
    }
  }

  function handleToggle() {
    const { isLegacyMode } = state

    handleLayoutSwitch()

    if (isLegacyMode) {
      setState((prevState) => ({ ...prevState, isLegacyMode: false }))
    } else {
      setState((prevState) => ({ ...prevState, isConfirmModalOpen: true }))
    }
  }

  function hideConfirmModal() {
    setState((prevState) => ({ ...prevState, isConfirmModalOpen: false }))
  }

  function switchMode() {
    setState((prevState) => ({ isConfirmModalOpen: false, isLegacyMode: !prevState.isLegacyMode }))
  }

  function importNewPublisher() {
    import('Pods/NewModelUploader/NewModelUploader')
      .then((module) => {
        NewModelUploader = module.default
        setState((prevState) => ({ ...prevState, isModuleLoaded: true }))
      })
      .catch((error) => {
        console.error('Failed to import NewModelUploader:', error)
      })
  }


  const { isLegacyMode, isConfirmModalOpen, isModuleLoaded } = state
  const haveNewPublisher = isModuleLoaded && NewModelUploader

  useEffect(() => {
    if (!haveNewPublisher && newPublisherView) {
      importNewPublisher()
    }
  }, [haveNewPublisher])

  if (newPublisherView) {
    return (
      <Fragment>
        {!isLegacyMode && (
          <div
            className={
              'cgt-tag cgt-legacy-back-color-grey-60 cgt-legacy-color-white-100 '
              + 'cgt-tag--clickable new-view-button'
            }
            onClick={handleToggle}
          >
            <span className="cgt-tag__text">Legacy View</span>
          </div>
        )}

        {!isLegacyMode ? (
          <Fragment>
            {haveNewPublisher ? (<NewModelUploader {...rest} />) : (<Spinner />)}
          </Fragment>
        ) : (
          <ModelUploader {...rest} onViewToggle={handleToggle} />
        )}

        {isConfirmModalOpen && (
          <ConfirmModal header={<ConfirmHeader />} onSubmit={switchMode} onCancel={hideConfirmModal}>
            This page supports fewer details, so some of the fields you’ve entered will be hidden.
          </ConfirmModal>
        )}
      </Fragment>
    )
  }

  return <ModelUploader {...rest} />
}

Publisher.propTypes = {
  newPublisherView: bool.isRequired,
}

export default Publisher
